// src/components/SummaryDrawer.jsx
import React from "react";
import {
  Box,
  Typography,
  Stack,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import AddToCart from "./AddToCart";
import { usePricing } from "../hooks/usePricing";
import { useData } from "../hooks/useData";

export default function SummaryDrawer({ open, onClose }) {
  const { totalPrice, formatPrice } = usePricing();
  const { lines } = useData();

  // Filter out empty lines for display
  const validLines = lines.filter((line) => line.text?.trim());

  return (
    <Box sx={{ p: 2 }}>
      {/* ===== LINE ITEMS ===== */}
      {validLines.length > 0 ? (
        <List disablePadding>
          {validLines.map((line, index) => (
            <ListItem key={line.id} disableGutters sx={{ py: 0.5 }}>
              <ListItemText
                primary={
                  <Typography variant="body2" noWrap>
                    Line {index + 1}: {line.text}
                  </Typography>
                }
                secondary={
                  <Typography variant="caption" color="text.secondary">
                    {line.sizeName} • {line.colorName} • {line.font}
                  </Typography>
                }
              />
              <Typography variant="body2" fontWeight="medium" sx={{ ml: 2 }}>
                ${Number(line.price || 0).toFixed(2)}
              </Typography>
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
          No text added yet.
        </Typography>
      )}

      <Divider sx={{ my: 2 }} />

      {/* ===== SUBTOTAL + ADD TO CART ===== */}
      <Box sx={{ mt: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="h6" fontWeight="bold">
            Subtotal
          </Typography>
          <Typography variant="h6" color="success.main" fontWeight="bold">
            {formatPrice(totalPrice)}
          </Typography>
        </Stack>

        <AddToCart />
      </Box>
    </Box>
  );
}